module.exports = __webpack_public_path__ + "img/item-3-2.0e48b5ae.png";